import React, { memo, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { Grid, Stack, Typography } from '@mui/material';
import CheckAndReturn from '../../../../utility/CheckAndReturn';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#4CB5F5',//theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

//FUNCTION
const PurchaseOrderItemTable = ({ purchaseOrderItems }) => {
    const [purchaseAmount, setPurchaseAmount] = useState(0);

    useEffect(() => {
        let totalPurchaseAmount = 0;

        purchaseOrderItems.forEach(row => {
            totalPurchaseAmount += Number(row.amount ?? 0);
        });

        setPurchaseAmount(totalPurchaseAmount);

        return () => {
            setPurchaseAmount(0);
        }
    }, [purchaseOrderItems]);

    return (
        <>
        {/*Destop View*/}
            <TableContainer component={Paper} sx={{ display: { xs: "none", sm: "none", lg: "block" } }}>
                <Box sx={{ overflowX: 'auto' }}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="left">S.No</StyledTableCell>
                                <StyledTableCell align="left">Item Code</StyledTableCell>
                                <StyledTableCell align="left">Item Name</StyledTableCell>
                                <StyledTableCell align="left">Order Qty</StyledTableCell>
                                <StyledTableCell align="left">Received Qty</StyledTableCell>
                                <StyledTableCell align="left">Returned Qty</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {purchaseOrderItems.length > 0 ? (
                                purchaseOrderItems.map((row, index) => (
                                    <StyledTableRow key={row.purchase_order_item_id ?? `${row.itemid}-${index}`}>
                                        <StyledTableCell align="left">{index + 1}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                            {row.item_code || '-'}
                                        </StyledTableCell>
                                        <StyledTableCell align="left">{row.item_name || '-'}</StyledTableCell>
                                        <StyledTableCell align="left">{row.qty ?? row.order_qty ?? '-'}</StyledTableCell>
                                        <StyledTableCell align="left">{row.received_qty ?? 0}</StyledTableCell>
                                        <StyledTableCell align="left">{row.returned_qty ?? row.rejected_qty ?? 0}</StyledTableCell>
                                    </StyledTableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={12} sx={{ textAlign: 'center', color: 'red', fontSize: '16px' }}>
                                        <div>
                                            <p><b>No Item Found.</b></p>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>
            </TableContainer>
            {/* mobile view whole item details in card view*/}
            <Grid container spacing={2} mt={2} sx={{ display: { xs: 'block', sm: 'block', lg: 'none' } }}>
                {purchaseOrderItems.map((row, index) => (
                    <Grid item xs={12} key={row.item_id}>
                        <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
                            <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                {index + 1}. {row.item_name}
                            </Typography>
                            <Grid container spacing={1} mt={1}>
                                <Grid item xs={6}>
                                    <Typography variant="body2">Code:</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2">{row.item_code || '-'}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2">Order Qty:</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2">{row.qty ?? row.order_qty ?? '-'}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2">Received Qty:</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2">{row.received_qty ?? 0}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2">Returned Qty:</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2">{row.returned_qty ?? row.rejected_qty ?? 0}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
            <Grid container spacing={1} mt={2}>
                <Grid container item xs={12} justifyContent={'flex-end'}>
                    <Stack direction={'row'} justifyContent={'flex-end'}>
                        <Typography variant='body1' sx={{ fontSize: '16px', fontWeight: 600 }}>
                            Purchase Amount:
                        </Typography>
                        <Typography variant='body1' sx={{ fontSize: '16px', fontWeight: 600, color: 'green' }}>
                            ₹{CheckAndReturn.roundToInteger(purchaseAmount ?? 0)}
                        </Typography>
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
};

export default memo(PurchaseOrderItemTable);
